module.exports = __webpack_public_path__ + "static/img/dr_ptanakar_photo.7a55c99e.png";